type Identifiers = { [key: string]: any }

function addElement<T>(arr: T[], newObject: T): T[] {
  return [...arr, newObject]
}

function updateElement<T extends Identifiers>(arr: T[], updatedObject: Partial<T>, identifiers: Identifiers): T[] {
  return arr.map((obj) => {
    const isMatch = Object.keys(identifiers).every((key) => obj[key] === identifiers[key])
    return isMatch ? { ...obj, ...updatedObject } : obj
  })
}

function deleteElement<T extends Identifiers>(arr: T[], identifiers: Identifiers): T[] {
  return arr.filter((obj) => {
    return !Object.keys(identifiers).every((key) => obj[key] === identifiers[key])
  })
}

type OperationType = 'ADD' | 'UPDATE' | 'DELETE'

export function handleArrOperations<T extends Identifiers>(
  arr: T[],
  payload: Partial<T> = {},
  operationType: OperationType = 'ADD',
  identifiers: Identifiers = {}
): T[] {
  switch (operationType) {
    case 'ADD':
      return addElement(arr, payload as T)
    case 'UPDATE':
      return updateElement(arr, payload, identifiers)
    case 'DELETE':
      return deleteElement(arr, identifiers)
    default:
      return arr
  }
}

export function findMatchingObject(arr: any, filter: any): any | -1 {
  for (const obj of arr) {
    let isMatch = true
    for (const key in filter) {
      if (Object.prototype.hasOwnProperty.call(filter, key) && obj[key] !== filter[key]) {
        isMatch = false
        break
      }
    }
    if (isMatch) {
      return obj
    }
  }
  return -1
}

export function sumByKey(array: any, sumKey: string, filterCriteria: { [key: string]: (string | number)[] }): number {
  return array.reduce((sum: number, obj: { [x: string]: string | number }) => {
    const matchesAllCriteria = Object.keys(filterCriteria).every((filterKey) =>
      filterCriteria[filterKey].includes(obj[filterKey])
    )

    if (matchesAllCriteria) {
      const value = +obj[sumKey]
      if (typeof value === 'number') {
        return sum + value
      }
    }

    return sum
  }, 0)
}

export function deepCopy<T>(array: T): T {
  return JSON.parse(JSON.stringify(array))
}
